const STACK_PAGE_MANAGER = 9999;
const DATE_PICKER = 5;
const PAGE_HEADER = 6;
// eg
// - Select (if rendered in Portal)
const DROPDOWN = 9999;
// Dropdown menu eg:
// - ButtonWithDropdown
// - ColorPicker,
const MODAL_BACKDROP = 100000;
const TOOLTIPTEXT = 999999;

const TOAST = STACK_PAGE_MANAGER + 1;
const FAB_CONTAINER = 100;
const VIEW_LEGEND = 999;
const VIEW_SIDE_PANEL = VIEW_LEGEND + 1;
const DETAILS_DRAWER = VIEW_SIDE_PANEL + 1;
const NAVIGATION_MENU = 10;
const TOUR_SPOTLIGHT = MODAL_BACKDROP + 10;

export const zIndex = {
  STACK_PAGE_MANAGER,
  DROPDOWN,
  TOAST,
  TOOLTIPTEXT,
  MODAL_BACKDROP,
  PAGE_HEADER,
  DATE_PICKER,
  FAB_CONTAINER,
  VIEW_LEGEND,
  VIEW_SIDE_PANEL,
  DETAILS_DRAWER,
  NAVIGATION_MENU,
  TOUR_SPOTLIGHT,
};
